module.exports = __webpack_public_path__ + "media/images/official/kv_sp2-e8dabd1a741f1b755e004d9a9fcfc14c.webp";